import React, { useEffect, useState } from "react";
import axios from "axios";
import { IoHome } from "react-icons/io5";
import { PiKeyReturnFill } from "react-icons/pi";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend,
} from "recharts";
import { useNavigate } from "react-router-dom";

import './VisitStats.css';

const API = process.env.REACT_APP_API;

function VisitStats() {
  const [visits, setVisits] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const navigate = useNavigate();  

  useEffect(() => {
    axios.get(`${API}/api/visits`)
      .then(res => {        
        // נעצב תצוגת חודש לקריאה נוחה
        const formatted = res.data.map(v => ({
          name: `${v.day}/${v.month}/${v.year}`,
          day: v.day,
          month: v.month,
          year: v.year,
          count: v.count,
        })).reverse();

        setVisits(formatted);
        setFiltered(formatted);
      })
      .catch(console.error);
  }, []);

  // 🔍 סינון לפי חודש ושנה
  useEffect(() => {
    let data = visits;
    if (selectedYear) data = data.filter(v => v.year === Number(selectedYear));
    if (selectedMonth) data = data.filter(v => v.month === Number(selectedMonth));
    setFiltered(data);
  }, [selectedMonth, selectedYear, visits]);

  const totalCount = filtered.reduce((sum, v) => sum + v.count, 0);

  const uniqueYears = [...new Set(visits.map(v => v.year))];
  const uniqueMonths = [...new Set(visits.map(v => v.month))];

  return (
    <div className="visit-stats-container">
      {/* ניווט */}
      <div className="home-icon">
        <IoHome title="עמוד הבית" size={30} onClick={() => navigate("/")} />
      </div>
      <div className="back-icon">
        <PiKeyReturnFill title="חזרה" size={40} onClick={() => navigate("/admin/users")} />
      </div>

      <h2 style={{ textAlign: "center", marginBottom: "20px" }}>📅 סטטיסטיקת כניסות יומית</h2>

      {/* 🔽 סינון */}
      <div className="filters" style={{ display: "flex", gap: "10px", justifyContent: "center", marginBottom: "15px" }}>
        <select value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)}>
          <option value="">כל החודשים</option>
          {uniqueMonths.map(m => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>

        <select value={selectedYear} onChange={e => setSelectedYear(e.target.value)}>
          <option value="">כל השנים</option>
          {uniqueYears.map(y => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>

        <button onClick={() => { setSelectedMonth(""); setSelectedYear(""); }}>איפוס</button>
      </div>

      {/* 🔢 סך הכול */}
      <div style={{ textAlign: "center", marginBottom: "15px", fontSize: "18px" }}>
        <strong>סה"כ כניסות:</strong> {totalCount.toLocaleString()}
      </div>

      {/* 📊 גרף */}
      <ResponsiveContainer width="115%" height={400}>
        <BarChart data={filtered}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Legend />
          <Bar dataKey="count" name="מס' כניסות" fill="#4f46e5" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default VisitStats;
